import TopBar from '../../components/TopBar';
import type { GuideSection as Section } from './guideContent';
import GuideText from './GuideText';
import styles from '../HelpGuide.module.css';

interface GuideSectionProps {
  section: Section;
  onBack: () => void;
  // Absent on the last section, and when opened as "?" help from the wizard: no Next.
  onNext?: () => void;
  // The return control's name: "Back to Guide" in the Guide, "Back to the question" from the wizard.
  backLabel?: string;
}

// One Guide section on its own screen (H1): the return control first, the numbered steps,
// then Next to the following section.
export default function GuideSection({ section, onBack, onNext, backLabel = 'Back to Guide' }: GuideSectionProps) {
  return (
    <main className={styles.container}>
      <TopBar title={section.title} backLabel={backLabel} onBack={onBack} />
      {section.intro && (
        <p className={styles.intro}>
          <GuideText text={section.intro} />
        </p>
      )}
      <ol className={styles.stepList}>
        {section.steps.map((step, i) => (
          <li key={i}>
            <GuideText text={step} />
          </li>
        ))}
      </ol>
      {onNext && (
        <button type="button" className={styles.nextButton} onClick={onNext}>
          Next <span aria-hidden="true">›</span>
        </button>
      )}
    </main>
  );
}
